import { TTotal } from "@/module/common";
import { SearchPageReq,SearchPageList } from "@/module/search";
import request from "@/utils/requset";
export const GetItemlist = () => { }

// 获取录播列表
export const getSearchPage = (data: SearchPageReq) => {
    return request<SearchPageReq, TTotal<SearchPageList[]>>({
        url: '/api/user/search/getsearchpage',
        method: 'POST',
        data
    })
}

